var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 89,
    viewBox: "0 0 364 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 14C132 6.26801 138.268 0 146 0H350C357.732 0 364 6.26801 364 14V74.5C364 82.232 357.732 88.5 350 88.5H14C6.26802 88.5 0 82.232 0 74.5V54.5C0 46.768 6.26801 40.5 14 40.5L111 40.5C122.598 40.5 132 31.098 132 19.5V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.65b52b56220db83de2bf18e68d4fb209.svg";
export { ForwardRef as ReactComponent };